export class LoadBookmarkRemoteStateAction {
  static type = '[BOOKMARK] Load bookmark remote state';
}
